import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import Unauthorized from '../pages/Unauthorized';

const PrivateRoute = ({ children, allowedRoles = [] }) => {
  const { user, isAuthenticated } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // Check userType (student/staff) or role (for staff: HOD, LIBRARY_STAFF, etc.)
  if (allowedRoles.length > 0) {
    const userRole = user?.userType || user?.role;
    const hasAccess = allowedRoles.some(role => 
      role.toLowerCase() === userRole?.toLowerCase() || 
      role === user?.role
    );
    
    if (!hasAccess) {
      return <Unauthorized />;
    }
  }

  return children;
};

export default PrivateRoute;
